/**
 * WS REST 网关开关与连接参数（协议 v1.3）。
 * USE_WSREST：构建时常量；true 时白名单 GET 走单例 WebSocket call，失败降级 HTTP。
 * 大 payload（>64KB 或 arb/stat/data）走 Text meta + Binary gzip 分片。
 * 回滚：设为 false 并重新构建。
 */
export const USE_WSREST = true;

export const WSREST_PING_INTERVAL_MS = 60_000;
export const WSREST_CALL_TIMEOUT_MS = 20_000;
export const WSREST_MAX_IN_FLIGHT = 18;
export const WSREST_RECONNECT_BASE_MS = 1_000;
export const WSREST_RECONNECT_MAX_MS = 30_000;
